export default {"src":"/_next/static/media/mock_mobile_dummy_order.6e261788.svg","height":89,"width":324,"blurWidth":0,"blurHeight":0};